import React, { useEffect, useState } from "react"
import { useTheme } from "../../context/ThemeContext"
import { longWordSlicing } from "../../helper-functions/CheckString"
import { Button, Spinner } from "react-bootstrap"
import { useFormik } from 'formik'
import * as Yup from 'yup'
import EditPageForm from "../Forms/EditPageForm"
import useGetTags from "../../hooks/useGetTags"
import { useBoardPersons, useFileUploader, useGetMember } from "../../hooks"
import { deletePage, deletePageFileAttachment, updatePageById } from "../../services/pages"
import ReactS3Client from 'react-aws-s3-typescript'
import { awsFileUploadConfig } from '../../config/awsFileUpload'
import { useSelector } from "react-redux"
import useGetPages from "../../hooks/useGetPages"
import { deleteFromAllSearchData, setUpdatedItem, updateSearchData } from "../../store/slice/home-searching-slice"
import { useDispatch } from "react-redux"
import { Dispatch } from '@reduxjs/toolkit'
import UserEditModal from "../../modules/user-management/users-list/user-edit-modal/UserEditModal"
import { getBoardPersonById } from "../../services/boards"
import { removePageById } from "../../store/slice/page-slice"
import DeletePageModal from "../Modals/DeletePageModal"


const pageUpdateSchema = Yup.object().shape({
    title: Yup.string()
        .min(3, 'Minimum 3 Characters')
        .max(235, 'Maximum 235 Characters')
        .required('Title is required')
        .trim(),
    webAppName: Yup.string()
        .min(3, 'Minimum 3 Characters')
        .max(300, 'Maximum 300 Characters').nullable()
        .trim(),
})

const EditPageForSearching: React.FC<any> = ({ page, setSelectedItem }: any) => {
    const { theme } = useTheme()
    const dispatch: Dispatch<any> = useDispatch()

    const [tocHeading, setTocHeading] = useState<any>(null);


    const { allBoards } = useSelector((state: any) => state.allBoardsReducer)

    const { getPageHandler, pageloading, page: getPage } = useGetPages(page.boardId)

    const s3 = new ReactS3Client({
        ...awsFileUploadConfig,
        dirName: `notes-attachments/${process.env.REACT_APP_ENVIRONMENT}`,
    })
    const [transformedTags, setTransformedTags] = useState<any>(page?.tags.map((tag: any) => ({
        value: tag.id,
        label: tag.name,
    })));
    const [selectedTags, setSelectedTags] = useState(transformedTags)


    const [selectedAssignee, setSelectedAssignee] = useState<any>([]);
    useEffect(() => {
        setSelectedOption(page?.status === 'active' ? { value: 'active', label: 'Active' } : page?.status === 'hidden' ? { value: 'hidden', label: 'Hidden' } : { value: 'archived', label: 'Archived' })
        if (page?.tags) {
            const tags = page.tags.map((tag: any) => ({
                value: tag.id,
                label: tag.name,
            }));
            setTransformedTags(tags);
            setSelectedTags(tags)
        }
        if (page?.board_people) {
            const assignees = page.board_people.map((people: any) => ({
                value: people.id,
                label: people.user.fullName,
            }));
            setSelectedAssignee(assignees);
        }

    }, [page?.id]);

    const [boardId, setBoardId] = useState(page.boardId)

    const [tagsToUpdate, setTagsToUpdate] = useState<any>({
        addedTags: [],
        removedTags: [],
    });
    const [assigneeToUpdate, setAssigneeToUpdate] = useState<any>({
        addedAssignee: [],
        removedAssignee: [],
    });

    const [editorTags, setEditorTags] = useState<any>(null)
    const [isPageSaved, setIsPageSaved] = useState(false)
    const [saveBtnProp, setSaveBtnProp] = useState({
        title: 'Save',
        color: 'primary',
    })
    const [disableBtn, setDisableBtn] = useState(false)
    const [showDetails, setShowDetails] = useState(false)
    const [editorDescriptionState, setEditorDescriptionState] = useState<any>(null)
    const [showPageDelete, setShowPageDelete] = useState(false)
    const [deletePageMsg, setDeletePageMsg] = useState('')
    const [disableDeletePageBtn, setDisableDeletePageBtn] = useState(false)

    const [socialMediaContent, setsocialMediaContent] = useState<any>(null)
    const [otherLinksContent, setOtherLinksContent] = useState<any>(null)
    const [optionsForSendAlertEdit, setOptionsForSendAlertEdit] = useState<any>(null)
    const [selectedOption, setSelectedOption] = useState<any>(page?.status === 'active' ? { value: 'active', label: 'Active' } : page?.status === 'hidden' ? { value: 'hidden', label: 'Hidden' } : { value: 'archived', label: 'Archived' })

    const initialValues = {
        title: page.title,
        webAppName: page.website_name,
    }
    // Tag options follow the live board selection, not the original page.boardId.
    const { tags, loading: tagsLoading } = useGetTags(boardId, 'page')
    const {
        optionsOfAssignee,
        isUserAssignLoading,
        selectAutoAssigneeForNotes,
        setSelectAutoAssigneeForNotes,
        optionsForSendAlert,
        // boardPersonsForSendAlert,
        getBoardPersonHandler,
    } = useBoardPersons(page)

    const { boardPerson } = useGetMember(boardId)
    const [openInviteModal, setOpenInviteModal] = useState(false)
    const { allSearchData } = useSelector((state: any) => state.homeSearchingReducer)


    const { fileErrorMsg, selectedFile, setSelectedFile, selectFileHandler, setFileErrorMsg } =
        useFileUploader()

    const deleteFileHandler = async (name: string, key: string, value: string) => {
        let files: any
        if (key) {
            files = selectedFile.filter((item: any) => item.key !== key)
        } else {
            files = selectedFile.filter((item: any) => item.name !== name)
        }
        try {
            const fileNameForDelete = value || name
            await s3.deleteFile(fileNameForDelete)
            try {
                key && await deletePageFileAttachment(page?.id, key)
                setSelectedFile(files)
            } catch (error) {
                return error
            }
        } catch (error) {
            return error
        }
    }
    const getAddedAndRemovedTags = () => {
        const addedTags = selectedTags?.filter((tag: any) => !transformedTags?.some((t: any) => t.value === tag.value));
        const removedTags = transformedTags?.filter((tag: any) => !selectedTags?.some((t: any) => t.value === tag.value));
        setTagsToUpdate({ addedTags, removedTags });
    };

    const getAddedAndRemovedAssignee = () => {
        const addedAssignee = selectAutoAssigneeForNotes?.filter((assignee: any) => !selectedAssignee.some((a: any) => a.value === assignee.value));
        const removedAssignee = selectedAssignee?.filter((assignee: any) => !selectAutoAssigneeForNotes.some((a: any) => a.value === assignee.value));

        setAssigneeToUpdate({ addedAssignee, removedAssignee });
    };

    const getTableOfContents = () => {
        const selectedPage = allSearchData.pages.pages?.find((p: any) => p.id === page.id)
        if (selectedPage?.description) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(page?.description, 'text/html');

            const headings = doc.querySelectorAll<HTMLHeadingElement>('h1, h2');

            const combinedTags = Array.from(headings).map((tag, index) => ({
                name: tag.textContent,
                tagName: tag.tagName.toLowerCase(),
                index,
            }));
            setEditorTags(combinedTags);
        }
    }
    useEffect(() => {
        if (page.id) getTableOfContents()
    }, [page.id])

    useEffect(() => {
        const urlLinks: any = []
        if (page?.file_attachments) {
            for (const file of page?.file_attachments) {
                for (const [key, value] of Object.entries(file)) {
                    const getFileName = (value as string)
                        .toLowerCase()
                        ?.split(`${process.env.REACT_APP_ENVIRONMENT}/`)[1]
                    urlLinks.push({ key, value: value, showName: getFileName })
                }
            }
            setSelectedFile(urlLinks)
        }
        return () => {
            setSelectedFile([]);
        };
        //eslint-disable-next-line
    }, [page])
    useEffect(() => {
        getAddedAndRemovedTags()
    }, [selectedTags])

    // Tags are board-specific: switching boards clears the original board's
    // selection so only the new board's tags can be assigned.
    useEffect(() => {
        setSelectedTags(boardId === page?.boardId ? transformedTags : [])
        //eslint-disable-next-line
    }, [boardId])

    useEffect(() => {
        getAddedAndRemovedAssignee()
    }, [selectAutoAssigneeForNotes])

    useEffect(() => {
        if (page?.board_people?.length) {
            const filteredOptions = optionsForSendAlert.filter((option: any) =>
                page.board_people.some((person: any) => person.user.fullName === option.label)
            );
            setOptionsForSendAlertEdit(filteredOptions);
        }
    }, [optionsForSendAlert, page]);

    useEffect(() => {
        if (boardId) {
            getBoardPersonHandler(boardId)
        }
        //eslint-disable-next-line
    }, [boardId, page])
    useEffect(() => {
        // getPageHandler(page?.id)
        setBoardId(page.boardId)
        //eslint-disable-next-line

    }, [page?.id])
    useEffect(() => {
        setEditorDescriptionState(page?.description)
        setsocialMediaContent(page?.socialLinks)
        setOtherLinksContent(page?.otherLinks)
        //eslint-disable-next-line

    }, [page])

    const handleSubmission = async () => {
        const urls = []
        for (let index = 0; index < selectedFile.length; index++) {
            const filename = selectedFile[index].name
            if (filename) {
                const filenameUpdated = filename.substring(0, filename.lastIndexOf('.'))
                try {
                    const uploadFile: any = await s3.uploadFile(selectedFile[index], filenameUpdated)
                    urls.push(uploadFile.location)
                } catch (error) {
                    return error
                }
            }
        }

        return urls
    }
    const deletePageHandler = async () => {
        setDisableDeletePageBtn(true)
        try {
            const res = await deletePage(page?.id)
            setDeletePageMsg(res.data.message)
            dispatch(deleteFromAllSearchData({ tab: 'pages', id: page?.id }))
            dispatch(removePageById(page?.id))
            setTimeout(() => {
                setShowPageDelete(false)

            }, 2000)
        }
        catch {
            // console.log(error)
        }
    }
    const getMembersHandler = async () => {
        try {
            const res = await getBoardPersonById(boardId)
            const resData = res.data.data
            const resObject: any = []
            for (let index = 0; index < resData.length; index++) {
                if (resData[index].isDeleted === false) {
                    resObject.push({
                        id: resData[index].id,
                        name: resData[index].user.fullName,
                        email: resData[index].user.email,
                        role: resData[index].role.name,
                        roleId: resData[index].roleId,
                        isOwner: resData[index].isOwner,
                    })
                }
            }
        } catch (error) {
            return error
        }
    }
    const formik = useFormik({
        initialValues,
        enableReinitialize: true,
        validationSchema: pageUpdateSchema,
        onSubmit: async (values: any) => {
            getAddedAndRemovedAssignee()
            setDisableBtn(true)

            const formData = new FormData();
            const fileLinks: any = await handleSubmission()
            const { title, webAppName } = values
            formData.append('title', title);
            webAppName && formData.append('website_name', webAppName);
            editorDescriptionState && formData.append('description', editorDescriptionState);

            otherLinksContent && formData.append('otherLinks', otherLinksContent);
            socialMediaContent && formData.append('socialLinks', socialMediaContent);

            formData.append('boardId', boardId);
            formData.append('status', selectedOption.value);

            tagsToUpdate.addedTags.forEach((tag: any) => formData.append('new_tagIds[]', tag.value));
            tagsToUpdate.removedTags.forEach((tag: any) => formData.append('remove_tagIds[]', tag.value));

            assigneeToUpdate.addedAssignee.forEach((assignee: any) => formData.append('new_assignee_board_person_ids[]', assignee.value));
            assigneeToUpdate.removedAssignee.forEach((assignee: any) => formData.append('remove_assignee_board_person_ids[]', assignee.value));

            fileLinks.forEach((link: string) => formData.append('new_file_attachments[]', link));
            try {
                const res = await updatePageById(page?.id, formData)
                const updatedPage: any = res.data.data.page
                setSelectedItem(updatedPage)

                // if (sendAlertTo.length > 0 && editorDescriptionState !== null)
                //     sendAlertToBoardPerson(updatedPage, sendAlertTo, 'page-description')

                const searchedCardData = allSearchData['Pages'.toLowerCase()]['Pages'.toLowerCase()]
                if (searchedCardData?.length > 0) {
                    const data = [...searchedCardData]
                    const index =
                        data?.length > 0 &&
                        (data?.findIndex((data: any) => data?.id === page?.id) as number)
                    if (index !== -1) {
                        data[index as number] = updatedPage
                        dispatch(setUpdatedItem([...data]))

                        dispatch(
                            updateSearchData({
                                tab: 'pages',
                                data: [...data],
                            })
                        )
                    }
                }
            } catch (error) {
                // console.log(error)
            } finally {
                setIsPageSaved(true)
                setDisableBtn(false)
                setSelectedFile([])
                setSaveBtnProp({ color: 'success', title: 'Saved' })

                setTimeout(() => {
                    setIsPageSaved(false)
                }, 3000)
            }
        }
    })
    return (
        <>
            <DeletePageModal deletePageMsg={deletePageMsg} setDeletePageMsg={setDeletePageMsg} disableBtn={disableDeletePageBtn} showPageDelete={showPageDelete} handleClose={() => setShowPageDelete(false)} deletePageHandler={deletePageHandler} title={page?.title?.trim()} />

            <div className='row d-flex justify-content-between border-bottom fs-2 fw-bold p-8 mb-5'>
                <div className='text-primary col-6 col-md-7'>

                    <span className={`responsive-font ${theme === 'dark' ? 'white__text' : ''} `} style={{ marginRight: 20 }}>

                        {longWordSlicing(page?.title?.trim())}
                    </span>

                </div>
                <div className='col-6 col-lg-5 d-flex justify-content-end align-items-center gap-1 text-end'>
                    {page?.status === 'archived' ?
                        (<div className='cursor-pointer bg-danger text-center py-1 px-2 me-2 d-flex justify-content-center align-items-center col-2 ' style={{ borderRadius: '8px' }}>
                            <span onClick={() => setShowPageDelete(true)}><i className={` bi bi-trash fs-3 p-1 mx-1 text-white`}></i></span>
                        </div>)
                        : null}
                    <Button
                        disabled={disableBtn || isUserAssignLoading || pageloading}
                        className={`${disableBtn && 'btn-custom-secondary '} btn-sm w-50 btn-${saveBtnProp.color
                            } `}
                        onClick={() => {
                            formik.handleSubmit()
                        }}
                    >
                        {
                            disableBtn ? (
                                <Spinner animation='border' variant='light' />
                            ) : (
                                <span>{saveBtnProp.title}</span>
                            )
                        }
                    </Button>
                    <button
                        type='button'
                        className={`btn btn-sm btn-outline-secondary modal-header-details-btn ${theme === 'dark' ? 'details-btn-dark' : 'text-dark'}`}
                        onClick={() => setShowDetails(true)}
                        title='Show details'
                    >
                        <i className={`bi bi-list-ul me-1 ${theme === 'dark' ? 'text-white' : 'text-dark'}`}></i>Details
                    </button>
                    {isPageSaved === true && (
                        <i
                            style={{
                                fontSize: 20,
                                color: '#51cd89',
                            }}
                            className='bi bi-check-lg'
                        ></i>
                    )}
                </div>
            </div>
            <div className='container'>
                <EditPageForm
                    theme={theme}
                    formik={formik}
                    editor={editorDescriptionState}
                    setEditor={setEditorDescriptionState}
                    boardId={boardId}
                    setBoardId={setBoardId}
                    allBoards={allBoards}
                    boardName={page?.board?.name || page?.boardName || page?.board_name}
                    tags={tags}
                    loading={tagsLoading}
                    selectedTags={selectedTags}
                    setSelectedTags={setSelectedTags}
                    boardPerson={boardPerson}
                    optionsForSendAlert={optionsForSendAlertEdit}
                    isUserAssignLoading={isUserAssignLoading}
                    setSelected={setSelectAutoAssigneeForNotes}
                    selected={selectAutoAssigneeForNotes}
                    options={optionsOfAssignee}
                    selectedOption={selectedOption} setSelectedOption={setSelectedOption}
                    loadingDesc={pageloading}
                    transformedTags={transformedTags}
                    deleteFileHandler={deleteFileHandler}
                    selectedFile={selectedFile}
                    changeHandler={selectFileHandler}
                    fileErrorMsg={fileErrorMsg}
                    setFileErrorMsg={setFileErrorMsg}
                    setOpenInviteModal={setOpenInviteModal}
                    socialMediaContent={socialMediaContent}
                    setsocialMediaContent={setsocialMediaContent}
                    otherLinksContent={otherLinksContent}
                    setOtherLinksContent={setOtherLinksContent}
                    editorTags={editorTags} setEditorTags={setEditorTags}
                    tocHeading={tocHeading} setTocHeading={setTocHeading}
                    updatedDate={page?.updatedAt}
                    pageId={page?.id}
                    envelopes={getPage?.envelopes || page?.envelopes}
                    getPageHandler={getPageHandler} pageloading={pageloading}
                    showDetails={showDetails}
                    setShowDetails={setShowDetails}
                />
            </div>
            {openInviteModal && (
                <UserEditModal membersData={optionsOfAssignee} getMembersHandler={getMembersHandler} sendWebSocket={undefined} isPage={true} setShow={setOpenInviteModal} show={openInviteModal} />
            )}
        </>
    )
}
export default EditPageForSearching